import * as i0 from '@angular/core';
import { InjectionToken, NgModule, Injectable, Inject } from '@angular/core';

const ENV_CONFIG = new InjectionToken('env.config');

class KupEnvModule {
    static forRoot(options) {
        return {
            ngModule: KupEnvModule,
            providers: [{ provide: ENV_CONFIG, useFactory: options.useFactory }],
        };
    }
}
KupEnvModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: KupEnvModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
KupEnvModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.2", ngImport: i0, type: KupEnvModule });
KupEnvModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: KupEnvModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: KupEnvModule, decorators: [{
            type: NgModule,
            args: [{}]
        }] });

class KupEnvService {
    constructor(env) {
        this.env = env;
    }
    get(key) {
        return this.env[key];
    }
}
KupEnvService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: KupEnvService, deps: [{ token: ENV_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
KupEnvService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: KupEnvService, providedIn: KupEnvModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: KupEnvService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: KupEnvModule,
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [ENV_CONFIG]
                    }] }];
    } });

/*
 * Public API Surface of kup-env library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { KupEnvModule, KupEnvService };
